"use client";

import { useTranslations } from "next-intl";
import { FilterCaloriesCalculator } from "@/features/filters/components/filter-calories-calculator";
import {
  FilterMulti,
  type FilterMultiProps,
} from "@/features/filters/components/filter-multi/filter-multi";
import type { FilterMultiType } from "@/features/filters/types/filter-multi.type";
import type { FiltersSetup } from "@/features/filters/types/filters-setup.type";

type FilterTagsProps = Omit<FilterMultiProps, "filter" | "paramName"> & {
  filtersSetup: FiltersSetup;
  filter?: FilterMultiType;
  paramName?: string;
};

export const FilterCalories = (params: FilterTagsProps) => {
  const {
    filtersSetup,
    collapsible,
    filter,
    paramName = "caloricity",
    ...rest
  } = params;
  const t = useTranslations();

  return (
    <>
      <FilterMulti
        collapsible={collapsible}
        collapsibleButtonLabel={t("filters.expand")}
        filter={{
          ...filter,
          label: t("filters.labels.caloricity"),
          name: paramName,
          total: filtersSetup.calories.length,
          value: [],
          options: filtersSetup.calories.map((item, index) => ({
            label: t("filters.kcal", { kcal: item.label }),
            value: item.label,
            additional: !!(
              index < 2 || index >= filtersSetup.calories.length - 2
            ),
          })),
        }}
        layout="columns"
        multiple={false}
        paramName={paramName}
        stretch={true}
        type="button"
        {...rest}
      />
      <FilterCaloriesCalculator
        caloriesRanges={filtersSetup.calories}
        form={params.asForm ? params.form : undefined}
        paramName={paramName}
      />
    </>
  );
};
